export default __webpack_public_path__ + "9dcd4f5ce9dd8bcad7be4e382d940794.svg";